import { render, staticRenderFns } from "./YAMLEditor.vue?vue&type=template&id=56ce1a5c&"
import script from "./YAMLEditor.vue?vue&type=script&lang=js&"
export * from "./YAMLEditor.vue?vue&type=script&lang=js&"
import style0 from "./YAMLEditor.vue?vue&type=style&index=0&id=56ce1a5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports